// Avatar.jsx
import React from 'react';
import { getInitials, stringToColor } from './utils';

const Avatar = ({ name, size = 50 }) => {
  const initials = getInitials(name);
  const backgroundColor = stringToColor(name);

  const avatarStyle = {
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: '50%',
    backgroundColor,
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    fontSize: `${size * 0.4}px`, // Scale font size dynamically with component sizing
    userSelect: 'none',
  };

  return (
    <div style={avatarStyle} aria-label={name}>
      {initials}
    </div>
  );
};

export default Avatar;
